import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/msgadd.png'
import _imports_1 from '@/assets/images/msgsearch.png'
import _imports_2 from '@/assets/images/checked.png'
import _imports_3 from '@/assets/images/checked_sel.png'
import _imports_4 from '@/assets/images/default_group.png'


const _withScopeId = n => (_pushScopeId("data-v-8d2d3196"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nav"
}
const _hoisted_2 = {
  key: 1,
  class: "topBox"
}
const _hoisted_3 = { class: "options" }
const _hoisted_4 = { class: "navTitle" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_6 = { class: "list" }
const _hoisted_7 = { class: "messageItem" }
const _hoisted_8 = { class: "cellitembox" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 1,
  class: "nodata"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_14 = { class: "title" }
const _hoisted_15 = { class: "subtitle" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  class: "flexBottom",
  style: {"margin-bottom":"env(safe-area-inset-bottom)"}
}
const _hoisted_20 = {
  key: 0,
  class: "checked",
  src: _imports_2,
  alt: ""
}
const _hoisted_21 = {
  key: 1,
  class: "checked",
  src: _imports_3,
  alt: ""
}
const _hoisted_22 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_lazy_component = _resolveComponent("lazy-component")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      ($setup.type == '1')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_van_nav_bar, {
              title: $setup.t('home.Message'),
              "left-arrow": "",
              fixed: "",
              "safe-area-inset-top": "",
              onClickLeft: $setup.onClickLeft
            }, null, 8 /* PROPS */, ["title"])
          ]))
        : _createCommentVNode("v-if", true),
      ($props.jumpType != 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.editPage = true))
              }, _toDisplayString($setup.editPage ? "" : $setup.t('im.edit')), 1 /* TEXT */),
              _withDirectives(_createElementVNode("img", {
                onClick: $setup.showDownApp,
                src: _imports_0,
                alt: ""
              }, null, 512 /* NEED_PATCH */), [
                [_vShow, (!$setup.isWebclip && !$setup.editPage && $setup.th != 'th')]
              ]),
              _withDirectives(_createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.editPage = false))
              }, _toDisplayString(_ctx.$t('im.wanc')), 513 /* TEXT, NEED_PATCH */), [
                [_vShow, $setup.editPage]
              ])
            ]),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('home.Message')), 1 /* TEXT */),
            _createCommentVNode(" <div class=\"searchBox\" @click=\"showDownApp\" v-if=\"!isWebclip\">\n        <img src=\"@/assets/images/msgsearch.png\" alt=\"\">\n        <span>搜索</span>\n      </div> "),
            _createElementVNode("div", {
              class: "searchBox",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.router.push('/imsearch')))
            }, [
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('im.search')), 1 /* TEXT */)
            ]),
            _createCommentVNode(" @click=\"router.push('/imsearch')\" ")
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_lazy_component, null, {
          default: _withCtx(() => [
            ($setup.msgList.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.msgList, (item) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_van_swipe_cell, null, {
                      right: _withCtx(() => [
                        _createVNode(_component_van_button, {
                          square: "",
                          onClick: ($event: any) => ($setup.delMsg(item)),
                          text: $setup.t('me.del'),
                          type: "danger",
                          class: "delete-button"
                        }, null, 8 /* PROPS */, ["onClick", "text"])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          ($setup.editPage && !item.checked)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "checked",
                                src: _imports_2,
                                alt: "",
                                onClick: ($event: any) => ($setup.editCheck(item.chatkey))
                              }, null, 8 /* PROPS */, _hoisted_9))
                            : _createCommentVNode("v-if", true),
                          ($setup.editPage && item.checked)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                class: "checked",
                                src: _imports_3,
                                alt: "",
                                onClick: ($event: any) => ($setup.editCheck(item.chatkey))
                              }, null, 8 /* PROPS */, _hoisted_10))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("div", {
                            onClick: ($event: any) => ($setup.toChat(item)),
                            class: "msgitem"
                          }, [
                            _createVNode($setup["MessageItem"], { data: item }, null, 8 /* PROPS */, ["data"])
                          ], 8 /* PROPS */, _hoisted_11)
                        ])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" <div v-else class=\"nodata\">\n          <img src=\"@/assets/images/zanwupinglun@3x.png\" alt=\"\">\n          <div class=\"title\">{{ $t('noData.noMsg') }}</div>\n          <div class=\"subtitle\">{{ $t('tips.tosendhd') }}</div>\n        </div> "),
            ($setup.props.jumpType == 2 && $setup.msgList.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, _toDisplayString($setup.props.isGroup == 2 ? _ctx.$t('暂无群组') : _ctx.$t('暂无与主播私聊信息')), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_15, _toDisplayString($setup.props.isGroup == 2 ? _ctx.$t('请找主播添加您进群获得福利') : _ctx.$t('请私信主播吧~')), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _createCommentVNode(" <layout v-if=\"type !== '1'\" /> ")
    ]),
    _createCommentVNode(" <van-overlay :show=\"downloadshow\" @click=\"downloadshow = false\" z-index=\"999\">\n    <div class=\"flexcenter\" style=\"min-height: 100vh\" @click.stop>\n      <div class=\"dolne\">\n        <div class=\"dolne-box\">\n          <img class=\"dolne-bg\" :src=\"showDialogBg\" alt=\"\" />\n          <img class=\"dolne-jiantou\" @click=\"open()\" :src=\"jiantou\" alt=\"\" />\n        </div>\n        <img class=\"dolne-on\" @click=\"downloadshow = false\" :src=\"ICON_CLOSE\" alt=\"\" />\n      </div>\n    </div>\n  </van-overlay> "),
    _createVNode(_component_van_overlay, {
      show: $setup.downloadshow,
      onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.downloadshow = false)),
      "z-index": "99999"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "wrapper",
          onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("img", {
            class: "bg",
            src: $setup.arterBg,
            alt: ""
          }, null, 8 /* PROPS */, _hoisted_16),
          _createElementVNode("img", {
            class: "btn",
            src: $setup.arterBtn,
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.open())),
            alt: ""
          }, null, 8 /* PROPS */, _hoisted_17),
          _createElementVNode("img", {
            class: "offbtn",
            src: $setup.offArterBtn,
            alt: "",
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.downloadshow = false))
          }, null, 8 /* PROPS */, _hoisted_18)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"]),
    _withDirectives(_createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", {
        class: "left",
        onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.onAllcheck()))
      }, [
        (!$setup.allCheck)
          ? (_openBlock(), _createElementBlock("img", _hoisted_20))
          : (_openBlock(), _createElementBlock("img", _hoisted_21)),
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('im.allSel')), 1 /* TEXT */)
      ]),
      _createElementVNode("div", {
        class: "right",
        onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.yidu()))
      }, _toDisplayString(_ctx.$t('im.yidu')), 1 /* TEXT */)
    ], 512 /* NEED_PATCH */), [
      [_vShow, $setup.editPage]
    ])
  ], 64 /* STABLE_FRAGMENT */))
}